// plan-01 S04: time helpers — 48 BPM clock, UTC formatting

export function now(): number {
  return Date.now()
}

export function utcNow(): { hh: string; mm: string; ss: string } {
  const d = new Date()
  return {
    hh: String(d.getUTCHours()).padStart(2, '0'),
    mm: String(d.getUTCMinutes()).padStart(2, '0'),
    ss: String(d.getUTCSeconds()).padStart(2, '0'),
  }
}

// 48 BPM = one cycle every 1.25 seconds (60/48)
const BPM48_PERIOD = 1.25

export function bpm48(): number {
  const seconds = performance.now() / 1000
  return (seconds % BPM48_PERIOD) / BPM48_PERIOD
}

// plan-12 S05: BPM phase for heartbeat sync with cursor
// Returns true when the heartbeat glyph should be visible (first half of cycle)
export function bpmPhase(): boolean {
  const seconds = performance.now() / 1000
  const phase = (seconds % BPM48_PERIOD) / BPM48_PERIOD
  return phase < 0.5
}
